import React from 'react';
import styled from '@emotion/styled';
import { Checkbox, Typography } from '@trustpilot/businessapp-patternlibrary';
import { SelectableBusinessUnit } from '../types';

interface BusinessUnitsProps {
  businessUnits: SelectableBusinessUnit[];
  onSelect: (id: string) => void;
  onSelectAll: (selected: boolean) => void;
  hasUnavailableBusinessUnits: boolean;
}

const Container = styled.div`
  margin-bottom: 24px;
`;

const Title = styled(Typography)`
  margin-bottom: var(--CDS-spacing-m);
`;

const BusinessUnitsContainer = styled.div`
  display: grid;
  grid-template-rows: none;
  grid-gap: 10px;
  grid-template-columns: 1fr 1fr;
  padding: 10px 16px;
  @media (max-width: 445px) {
    grid-template-columns: 1fr;
  }
`;

const Note = styled(Typography)`
  margin-top: 16px;
  color: #292929;
  font-style: italic;
`;

const BusinessUnits = ({
  businessUnits,
  onSelect,
  onSelectAll,
  hasUnavailableBusinessUnits,
}: BusinessUnitsProps) => {
  const selectedBusinessUnitsLength = businessUnits.filter(
    (businessUnit) => businessUnit.selected
  ).length;
  const selectableBusinessUnitsLength = businessUnits.filter(
    (businessUnit) => !businessUnit.disabled
  ).length;

  return (
    <Container>
      <Title variant="heading-s">Select domains</Title>
      <Checkbox
        indeterminate={
          selectedBusinessUnitsLength > 0 &&
          selectedBusinessUnitsLength < selectableBusinessUnitsLength
        }
        checked={selectedBusinessUnitsLength === selectableBusinessUnitsLength}
        onChange={() => {
          onSelectAll(selectedBusinessUnitsLength !== selectableBusinessUnitsLength);
        }}
      >
        All domains
      </Checkbox>
      <BusinessUnitsContainer>
        {businessUnits.map((businessUnit: SelectableBusinessUnit) => (
          <Checkbox
            key={businessUnit.id}
            checked={businessUnit.selected}
            disabled={businessUnit.disabled}
            onChange={() => onSelect(businessUnit.id)}
          >
            {businessUnit.identifyingName}
          </Checkbox>
        ))}
      </BusinessUnitsContainer>
      {hasUnavailableBusinessUnits && (
        <Note variant="body-s">
          Note: Some of your websites are not available, contact your account
          manager for more information.
        </Note>
      )}
    </Container>
  );
};

export default BusinessUnits;
